import React, { useState } from 'react';
import { Box, Tabs, Tab, Container, Paper, Button, Typography } from '@mui/material';
import { useParams, Link as RouterLink, useNavigate } from 'react-router-dom';
import MenuOptionGroupManagement from './MenuOptionGroup/MenuOptionGroupManagement';
import MenuOptionItemManagement from './MenuOptionItem/MenuOptionManagement';
import MenuOptionAttachment from './MenuOptionAttachment/MenuOptionAttachment';
import Header from '../../Components/Header/Header';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`menu-option-tabpanel-${index}`}
      aria-labelledby={`menu-option-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `menu-option-tab-${index}`,
    'aria-controls': `menu-option-tabpanel-${index}`,
  };
}

const MenuOptionManagement: React.FC = () => {

  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const { store_id } = useParams<{ store_id: string }>();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  if (!store_id) {
    return null;
  }

  return (
    <Box>
      <Header />
      <Container maxWidth="lg">
        <Box sx={{ width: '100%', mt: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" component="h1">
            メニューオプション管理
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(`/${store_id}/manage/menu`)}
            >
              メニュー管理
            </Button>
          </Box>
        </Box>
          <Paper>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="menu option management tabs">
                <Tab label="グループ管理" {...a11yProps(0)} />
                <Tab label="オプション管理" {...a11yProps(1)} />
                <Tab label="オプションの紐付け" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <MenuOptionGroupManagement storeId={store_id} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <MenuOptionItemManagement storeId={store_id} />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <MenuOptionAttachment storeId={store_id} />
            </TabPanel>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default MenuOptionManagement;
